import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import { fetchWithJWT } from "@/futurelayer/auth/jwt";

export type UnsplashImage = {
  id: string;
  description: string | null;
  alt_description: string | null;
  urls: {
    raw: string;
    full: string;
    regular: string;
    small: string;
    thumb: string;
  };
  user: {
    name: string;
    username: string;
  };
  width: number;
  height: number;
}

export type UnsplashSearchResponse = {
  total: number;
  total_pages: number;
  results: UnsplashImage[];
}

export type UnsplashRequest = {
  query: string;
  page: number;
  per_page: number;
}

export async function callUnsplash(
  request: UnsplashRequest,
  abortController: AbortController
): Promise<UnsplashImage[]> {

  if (request.per_page === 0) {
    throw new Error("per_page must be greater than 0");
  };

  try {
    const response = await fetchWithJWT("/stock-photos/unsplash", {
      body: jsonStringifyOrUndefined(request),
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result: UnsplashSearchResponse = await response.json();
    return result.results;
  } catch (error) {
    console.error("Unsplash request failed:", error);
    throw error;
  }
}

// Usage example:
// const images = await callUnsplash({
//   query: "nature",
//   page: 1,
//   per_page: 10
// });
